exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs[data-v-3ae7bab0]{font-size:10px;color:#9b9b9b;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;list-style:none;padding:12px;margin:0;background:#f3f3f3;-webkit-box-shadow:0 1px 0 #ededed,inset 0 1px 0 #ededed;box-shadow:0 1px 0 #ededed,inset 0 1px 0 #ededed}.breadcrumbs>a[data-v-3ae7bab0]{color:#9b9b9b;text-decoration:none}.breadcrumbs>a[data-v-3ae7bab0]:first-child{margin-right:8px}.breadcrumbs>a[data-v-3ae7bab0]:nth-child(1n+2){margin:0 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ae7bab0","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/BreadCrumb.vue
// module id = M27q
// module chunks = 0